import React from "react";
import ListUser from "./ListUser";
import ListKorwil from "./ListKorwil";
import ListAreaManager from "./ListAreaManager";
import ListSupervisor from "./ListSupervisor";
import ListMarketing from "./ListMarketing";
import { Card, Nav, Container, Row, Col, Tab } from "react-bootstrap";
import { useSelector } from "react-redux";
import ListBPD from "./ListBPD";

function IndexUser() {
  const auth = useSelector((state) => state.authReducer);
  const [role, setRole] = React.useState("");

  React.useEffect(() => {
    if (auth.role) {
      setRole(auth.role);
    }
  }, [auth.role]);

  if (!role) {
    return <div></div>;
  }
  return (
    <>
      <Container fluid className="pt-3">
        <Row>
          <Col md="12">
            <Card
              className="border-0 shadow-sm"
              style={{ borderRadius: "20px", overflow: "hidden" }}
            >
              <Card.Header className="bg-white border-0 pt-4 px-4">
                <div className="d-flex align-items-center">
                  <div
                    style={{
                      width: "12px",
                      height: "30px",
                      backgroundColor: "#1D3557",
                      borderRadius: "10px",
                      marginRight: "15px",
                    }}
                  />
                  <Card.Title
                    as="h3"
                    style={{
                      color: "#1e293b",
                      textTransform: "uppercase",
                      fontWeight: "800",
                      margin: 0,
                      letterSpacing: "1px",
                    }}
                  >
                    Manajemen Daftar User
                  </Card.Title>
                </div>
                <p
                  className="text-muted mt-2 ml-4"
                  style={{ fontSize: "14px" }}
                >
                  Kelola data akun, penempatan, dan akses berdasarkan kategori
                  role.
                </p>
              </Card.Header>

              <Card.Body className="px-4 pb-4">
                <Tab.Container
                  id="user-management-tabs"
                  defaultActiveKey={role === "super admin" ? "user" : "korwil"}
                >
                  {/* NAVIGASI TAB DENGAN GAYA MODERN PILLS */}
                  <Nav
                    variant="pills"
                    className="flex-nowrap mb-4 pb-2"
                    style={{
                      overflowX: "auto",
                      borderBottom: "1px solid #f1f5f9",
                      gap: "10px",
                      whiteSpace: "nowrap",
                      display: "flex",
                    }}
                  >
                    {role === "super admin" && (
                      <Nav.Item>
                        <Nav.Link eventKey="user" className="custom-tab-link">
                          <i className="fas fa-users-cog mr-2"></i> User Admin
                        </Nav.Link>
                      </Nav.Item>
                    )}
                    <Nav.Item>
                      <Nav.Link eventKey="korwil" className="custom-tab-link">
                        <i className="fas fa-map-marked-alt mr-2"></i> Korwil
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="areamaneger"
                        className="custom-tab-link"
                      >
                        <i className="fas fa-user-tie mr-2"></i> Area Manager
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="supervisor"
                        className="custom-tab-link"
                      >
                        <i className="fas fa-user-shield mr-2"></i> Supervisor
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="marketing"
                        className="custom-tab-link"
                      >
                        <i className="fas fa-ad mr-2"></i> Sales Marketing
                      </Nav.Link>
                    </Nav.Item>
                    {role === "super admin" && (
                      <Nav.Item>
                        <Nav.Link eventKey="korcab" className="custom-tab-link">
                          <i className="fas fa-university mr-2"></i> BPD
                        </Nav.Link>
                      </Nav.Item>
                    )}
                  </Nav>

                  <Tab.Content className="mt-2">
                    <Tab.Pane eventKey="user">
                      <ListUser />
                    </Tab.Pane>
                    <Tab.Pane eventKey="korwil">
                      <ListKorwil />
                    </Tab.Pane>
                    <Tab.Pane eventKey="areamaneger">
                      <ListAreaManager />
                    </Tab.Pane>
                    <Tab.Pane eventKey="supervisor">
                      <ListSupervisor />
                    </Tab.Pane>
                    <Tab.Pane eventKey="marketing">
                      <ListMarketing />
                    </Tab.Pane>
                    <Tab.Pane eventKey="korcab">
                      <ListBPD />
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* CSS INTERNAL UNTUK TAB (Tambahkan di file CSS Anda atau gunakan style tag) */}
        <style>{`
    .custom-tab-link {
      color: #64748b !important;
      font-weight: 700 !important;
      border-radius: 12px !important;
      padding: 12px 20px !important;
      transition: all 0.3s ease !important;
      background: transparent !important;
      font-size: 14px;
    }
    .custom-tab-link.active {
      background-color: #1D3557 !important;
      color: white !important;
      box-shadow: 0 8px 15px rgba(29, 53, 87, 0.2) !important;
    }
    .custom-tab-link:hover:not(.active) {
      background-color: #f1f5f9 !important;
      color: #1D3557 !important;
    }
    /* Hide scrollbar tapi tetap bisa scroll di mobile */
    .nav-pills::-webkit-scrollbar {
      display: none;
    }
  `}</style>
      </Container>
    </>
  );
}

export default IndexUser;
